import { IKeHoachHocLaiActions } from "../../action-types/ke-hoach-hoc-lai/IKeHoachHocLaiActions"
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IKeHoachHocLaiReducer } from "../../reducer-model/ke-hoach-hoc-lai/IKeHoachHocLaiReducer"
const iniState: IKeHoachHocLaiReducer = {
    status: eReducerStatusBase.is_not_initialization,
    keHoachMonHocLais: [],
    isShowPhamViLop: false,
    lopTinChiFocusedId: 0,
    addMonHocModal: {
        is_open: false,
        id_mon_selecteds: []
    },
    filter: {
        hoc_ky: 0,
        nam_hoc: "",
        id_chuyen_nganh: 0,
        id_he: 0,
        id_mon: 0,
        id_nganh: 0,
        khoa_hoc: 0,
        ky_dang_ky: 0,
        stu_nhomlop_id: 0,
        id_bm: 0,
    },
    sort_mode: "lich-hoc"
}
export const keHoachHocLaiReducer =
    (state: IKeHoachHocLaiReducer = iniState, action: IKeHoachHocLaiActions): IKeHoachHocLaiReducer => {
        switch (action.type) {
            case "KE_HOACH_HOC_LAI_CHANGE_FILTER":
                return {
                    ...state,
                    filter: action.payload
                }
            case "KE_HOACH_HOC_LAI_UPDATE_ADD_MONHOC_MODAL":
                return {
                    ...state,
                    addMonHocModal: { ...state.addMonHocModal, ...action.payload }
                }
            case "KE_HOACH_HOC_LAI_ADD_MONHOC_START":
                return {
                    ...state,
                    status: eReducerStatusBase.is_saving
                }
            case "KE_HOACH_HOC_LAI_ADD_MONHOC_SUCCESS":
                return {
                    ...state,
                    status: eReducerStatusBase.is_need_reload,
                    addMonHocModal: {
                        ...state.addMonHocModal,
                        is_open: false
                    }
                }
            case "KE_HOACH_HOC_LAI_ADD_MONHOC_ERROR":
                return {
                    ...state,
                    status: eReducerStatusBase.is_completed
                }
            case "KE_HOACH_HOC_LAI_LOAD_START":
                return {
                    ...state,
                    status: eReducerStatusBase.is_loading
                }
            case "KE_HOACH_HOC_LAI_LOAD_SUCCESS":
                return {
                    ...state,
                    status: eReducerStatusBase.is_completed,
                    keHoachMonHocLais: action.payload
                }
            case "KE_HOACH_HOC_LAI_LOAD_ERROR":
                return {
                    ...state,
                    status: eReducerStatusBase.is_completed
                }
            case "KE_HOACH_HOC_LAI_SHOW_PHAM_VI_LOP_MODAL":
                return {
                    ...state,
                    isShowPhamViLop: action.payload
                }
            case "KE_HOACH_HOC_LAI_CHANGE_FOCUSED_ID":
                return {
                    ...state,
                    lopTinChiFocusedId: action.payload
                }
            case "KE_HOACH_HOC_LAI_SAVE_PHAM_VI_START":
                return {
                    ...state,
                    status: eReducerStatusBase.is_saving
                }
            case "KE_HOACH_HOC_LAI_SAVE_PHAM_VI_SUCCESS":
                return {
                    ...state,
                    status: eReducerStatusBase.is_completed,
                    keHoachMonHocLais: state.keHoachMonHocLais.map(x => {
                        if (action.payload.length === 0) {
                            return {
                                ...x,
                                lopTinChi: { ...x.lopTinChi, phamVis: [] }
                            }
                        }
                        else if (action.payload.some(p => p.id_lop_tc === x.lopTinChi?.id_lop_tc)) {
                            return {
                                ...x,
                                lopTinChi: { ...x.lopTinChi, phamVis: action.payload.filter(p => p.id_lop_tc === x.lopTinChi?.id_lop_tc) }
                            }
                        }
                        return x;
                    })
                }
            case "KE_HOACH_HOC_LAI_SAVE_PHAM_VI_ERROR":
                return {
                    ...state,
                    status: eReducerStatusBase.is_completed
                }
            case "KE_HOACH_HOC_LAI_UPDATE_INFO_SU_KIEN_START":
                return {
                    ...state,
                    status: eReducerStatusBase.is_saving
                }
            case "KE_HOACH_HOC_LAI_UPDATE_INFO_SU_KIEN_SUCCESS":
                return {
                    ...state,
                    status: eReducerStatusBase.is_completed,
                    keHoachMonHocLais: state.keHoachMonHocLais.map(x => {
                        const suKiens = action.payload.filter(sk => sk.id_lop_tc === x.lopTinChi?.id_lop_tc);
                        if (suKiens.length > 0) {
                            return {
                                ...x,
                                lopTinChi: { ...x.lopTinChi, suKiens: suKiens }
                            }
                        }
                        return x;
                    })
                }
            case "KE_HOACH_HOC_LAI_UPDATE_INFO_SU_KIEN_ERROR":
                return {
                    ...state,
                    status: eReducerStatusBase.is_completed
                }
            case "KE_HOACH_HOC_LAI_CHANGE_SORT_MODE":
                return {
                    ...state,
                    sort_mode: action.payload
                }
            case "KE_HOACH_HOC_LAI_UPDATE_LOP_TIN_CHI_START":
                return {
                    ...state,
                    status: eReducerStatusBase.is_saving
                }
            case "KE_HOACH_HOC_LAI_UPDATE_LOP_TIN_CHI_SUCCESS":
                return {
                    ...state,
                    status: eReducerStatusBase.is_completed,
                    keHoachMonHocLais: state.keHoachMonHocLais.map(x => {
                        if (x.lopTinChi?.id_lop_tc === action.payload.id_lop_tc) {
                            return {
                                ...x,
                                lopTinChi: {
                                    ...x.lopTinChi,
                                    ten_lop_hp: action.payload.ten_lop_hp,
                                    ghi_chu: action.payload.ghi_chu,
                                }
                            }
                        }
                        return x;
                    })
                }
            case "KE_HOACH_HOC_LAI_UPDATE_LOP_TIN_CHI_ERROR":
                return {
                    ...state,
                    status: eReducerStatusBase.is_completed
                }
            default:
                return { ...state };
        }
    }